<template>
  <div>
    <h6 class="text-two">
      {{ question.semiology_form_question_type_description }}
    </h6>
    <ChromeSpeechToTextTextarea
      rows="4"
      max-rows="10"
      v-model="answer"
      @input="input"
    />
  </div>
</template>

<script>
import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";
export default {
  components: { ChromeSpeechToTextTextarea },
  name: "Question",
  props: {
    category_id: [String, Number],
    question: Object,
  },
  data() {
    return {
      answer: "",
    };
  },
  created() {
    setTimeout(
      () =>
        this.$emit("answer", {
          category_id: this.category_id,
          id: this.question.id,
          text: "",
          answer: this.question.alternatives[0].id,
        }),
      200
    );
  },
  methods: {
    async input() {
      this.$emit("answer", {
        category_id: this.category_id,
        id: this.question.id,
        text: this.answer,
        answer: this.question.alternatives[0].id,
      });
    },
  },
};
</script>
